import ArrivalProcessPage from './ArrivalProcessPage.jsx'
import container from './container.js'

export default container(ArrivalProcessPage)
